import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const NoteSuc: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_31588)'>
        <path
          d='M4.1021 1.00071H19.7454C19.9985 1.00071 20.203 1.20591 20.203 1.45829V18.9912C20.203 19.1199 20.1501 19.2365 20.0643 19.3194L16.5174 22.8663C16.4287 22.9535 16.3186 22.9993 16.1942 23H4.1021C3.84901 23 3.64453 22.7948 3.64453 22.5424V1.45757C3.64453 1.20448 3.84901 1 4.1021 1V1.00071ZM11.9152 13.7048C11.6628 13.7048 11.4576 13.4996 11.4576 13.2472C11.4576 12.9949 11.6628 12.7897 11.9152 12.7897H17.617C17.8701 12.7897 18.0745 12.9949 18.0745 13.2472C18.0745 13.5003 17.8694 13.7048 17.617 13.7048H11.9152ZM7.24792 12.9849C7.04702 12.834 7.00555 12.548 7.15641 12.3471C7.30727 12.1455 7.59325 12.1047 7.79487 12.2556L9.01816 13.1707L10.9064 10.4182C11.0479 10.2101 11.3325 10.1558 11.5405 10.298C11.7486 10.4403 11.8029 10.7242 11.6607 10.9322L9.50362 14.078L9.5029 14.0773L9.49075 14.0938C9.33989 14.2947 9.05391 14.3361 8.85229 14.1853L7.24792 12.9841V12.9849ZM9.93831 14.6929C9.93831 14.4405 10.1435 14.2353 10.3959 14.2353C10.649 14.2353 10.8535 14.4405 10.8535 14.6929V15.3306C10.8535 15.5837 10.649 15.7882 10.3959 15.7882H6.22982C5.97673 15.7882 5.77225 15.583 5.77225 15.3306V11.1646C5.77225 10.9122 5.97744 10.707 6.22982 10.707H8.97741C9.22979 10.707 9.43498 10.9122 9.43498 11.1646C9.43498 11.4177 9.22979 11.6221 8.97741 11.6221H6.6874V14.8731H9.93831V14.6929ZM11.9152 6.94631C11.6628 6.94631 11.4576 6.74112 11.4576 6.48874C11.4576 6.23564 11.6628 6.03117 11.9152 6.03117H17.617C17.8701 6.03117 18.0745 6.23636 18.0745 6.48874C18.0745 6.74183 17.8694 6.94631 17.617 6.94631H11.9152ZM7.24792 6.22635C7.04702 6.07549 7.00555 5.78951 7.15641 5.58789C7.30727 5.38699 7.59325 5.34552 7.79487 5.49709L9.01816 6.41224L10.9064 3.65893C11.0479 3.45088 11.3325 3.39726 11.5405 3.53953C11.7486 3.68181 11.8029 3.96565 11.6607 4.1737L9.50362 7.31952H9.5029L9.49075 7.33596C9.33989 7.53687 9.05391 7.57834 8.85229 7.42748L7.24792 6.22635ZM9.93831 7.93439C9.93831 7.68129 10.1435 7.47681 10.3959 7.47681C10.649 7.47681 10.8535 7.682 10.8535 7.93439V8.57213C10.8535 8.82522 10.649 9.0297 10.3959 9.0297H6.22982C5.97673 9.0297 5.77225 8.82451 5.77225 8.57213V4.40606C5.77225 4.15297 5.97744 3.94849 6.22982 3.94849H8.97741C9.22979 3.94849 9.43498 4.15297 9.43498 4.40606C9.43498 4.65916 9.22979 4.86364 8.97741 4.86364H6.6874V8.11455H9.93831V7.93439ZM15.7359 22.0863V18.9919C15.7359 18.7396 15.9411 18.5344 16.1935 18.5344H19.2878V1.91658H4.55968V22.0863H15.7359ZM16.6511 19.4495V21.4392L17.6463 20.4447L18.6408 19.4502H16.6511V19.4495Z'
          fill='url(#paint0_linear_12280_31588)'
          stroke='url(#paint1_linear_12280_31588)'
          strokeWidth='0.3'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_31588'
          x1='7.07341'
          y1='2.50015'
          x2='18.6308'
          y2='19.9349'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_31588'
          x1='7.07341'
          y1='2.50015'
          x2='18.6308'
          y2='19.9349'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_31588'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoteSuc;
